import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { useField, useFormikContext } from 'formik';
import { useCallback } from 'react';
const DateField = (props) => {
    const [field, meta] = useField(props.name);
    const { setFieldValue } = useFormikContext();
    const error = meta.touched && !!meta.error;
    const errorMessage = error ? meta.error : undefined;
    const onChange = useCallback((value) => {
        setFieldValue(field.name, value);
        if (props.onChange) {
            props.onChange(value);
        }
    }, [field.name, props, setFieldValue]);
    const renderDatePickInput = useCallback((params) => (_jsx(TextField, { ...params, error: meta.touched && !!meta.error, name: field.name, value: field.value ? dayjs(field.value).format('DD/MM/YYYY') : '', onBlur: field.onBlur, onChange: props.onChange, label: props.label, helperText: errorMessage, variant: "outlined", margin: "dense", required: props.required, placeholder: props.placeholder, sx: { ...{ width: '90%' }, ...props.sx } })), [
        field,
        meta,
        props.required,
        props.onChange,
        props.placeholder,
        props.label,
        props.sx,
        errorMessage,
    ]);
    const widthVar = 'width';
    const width = props.sx ? props.sx[widthVar] : '90%';
    if (props.isLoading) {
        return (_jsx(Skeleton, { variant: "rounded", height: "3rem", width: width, sx: { marginTop: '1rem', ...props.skeletonSx } }));
    }
    return (_jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, children: _jsx(DatePicker, { label: props.placeholder, value: dayjs(field.value), onChange: onChange, renderInput: renderDatePickInput, inputFormat: 'DD/MM/YYYY' }) }));
};
export { DateField };
